module.exports = __webpack_public_path__ + "media/images/SF_logo-749cbf7e8fa78ef758fba8a78e818af0.svg";